import { BehaviorSubject } from "rxjs";

export const GlobalVariables = {
  alainMode: new BehaviorSubject<boolean>(false),
};
